import { Button } from '@headlessui/react';
import { motion } from 'motion/react'; // eslint-disable-line
import PropTypes from 'prop-types';
import brandCardBackground from '@assets/images/brand-card-bg.png';

function CorporateDialog({
  title = '',
  description = '',
  buttonText = '',
  onButtonClick,
}) {
  return (
    <>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        style={{
          backgroundImage: `url(${brandCardBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
        }}
        className="border-1 p-5 border-corporate-golden-light w-[85vw] h-[85vw] md:w-[50vw] md:h-[50vw] lg:w-[20vw] lg:h-[20vw] flex flex-col items-center justify-center"
      >
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-wide mb-4">
          {title}
        </h1>
        <p className="text-md sm:text-lg md:text-xl lg:text-2xl font-sans">
          {description}
        </p>
      </motion.div>
      {buttonText && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="flex justify-center mt-5"
        >
          <Button
            onClick={onButtonClick}
            className="text-2xl font-sans text-corporate-golden-dark hover:text-corporate-golden-dark/50 active:text-corporate-golden-dark/80"
          >
            {buttonText}
          </Button>
        </motion.div>
      )}
    </>
  );
}

CorporateDialog.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
};

CorporateDialog.defaultProps = {
  buttonText: '',
  onButtonClick: () => {},
};

export default CorporateDialog;
